import { SatelliteType } from "../weatherTable/satellite/satelitteType.dto";

export class PointDto {
    public seq: number = 0;
    public name: string = "";
    public address!: string;
    public latitude!: number;
    public longitude!: number;
    public altitude!: number;
    public accountSeq!: number;

    public isReverse!: boolean;
    public isKorean!: boolean;

    public angle: number = 85;
    public satelliteType: SatelliteType = SatelliteType.ADDGALILEO;
    public timeOffset!: number | null;

    public isValidPlaceName(): boolean {
        return /^.{1,30}$/.test(this.name);
    }

    public isValidBookmark(): boolean {
        if (this.name == undefined || !this.isValidPlaceName()
            || this.altitude == undefined || this.accountSeq == undefined) {
            return false;
        }

        return true;
    }

    public setTimeOffset(utcOffset: string | null): void {
        if (utcOffset) {
            this.timeOffset = parseInt(utcOffset.substring(0, 3));
        }
    }

    public toGeocodingRequestDto(): {} {
        let {seq, name, altitude, accountSeq, angle, satelliteType, timeOffset, ...geocodignRequestDto} = this;
        return geocodignRequestDto;
    }

    public toLocationDto(): {} {
        let {name, isReverse, isKorean, angle, satelliteType, timeOffset, ...locationDto} = this;
        return locationDto;
    }

    public toBookmarkDto(): {} {
        let {isReverse, isKorean, angle, satelliteType, timeOffset, ...bookmarkDto} = this;
        return bookmarkDto;
    }

    public toSearchDto(): {} {
        let {seq, name, address, accountSeq, isReverse, isKorean, ...searchDto} = this;
        return searchDto;
    }
}
